var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("content flex-column justify-center bookpage " + (_vm.visible ? 'current-page' : '')),style:({ display: _vm.visible ? 'flex' : 'none' }),attrs:{"id":'bookpage_' + _vm.pageNumber},domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }